import API from '~/Api';

export const AUTH_CALLBACK_PATH = '/auth/callback';
export const AUTH_INTENT_QUERY_PARAM = 'auth_intent';
export const AUTH_INTENT_UPGRADE_PAYWALL = 'upgrade_paywall';

export type CallbackProvider = 'email' | 'google' | 'meta' | 'microsoft';

type AuthExchangeResult = {
  access_token: string;
  refresh_token: string;
  is_new_user?: boolean;
};

type ProviderConfig = {
  // Which URL query param the backend puts the handoff token in for this
  // provider (email magic link uses `token`; OAuth callbacks append
  // `{provider}_oauth_token`).
  tokenParam: string;
  exchange: (token: string) => Promise<AuthExchangeResult>;
};

// Per-provider landing config. Add a provider = one entry.
export const PROVIDER_CONFIG: Record<CallbackProvider, ProviderConfig> = {
  email: {
    tokenParam: 'token',
    exchange: (token) => API.exchangeChatAuthEmail(token),
  },
  google: {
    tokenParam: 'google_oauth_token',
    exchange: (token) => API.exchangeOAuthSession('google', token),
  },
  meta: {
    tokenParam: 'meta_oauth_token',
    exchange: (token) => API.exchangeOAuthSession('meta', token),
  },
  microsoft: {
    tokenParam: 'microsoft_oauth_token',
    exchange: (token) => API.exchangeOAuthSession('microsoft', token),
  },
};
